/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import { GNB_BASE_URL, LOAD_BASE_URL } from '../../config';

const tag = {};
const opt = {};

opt.gnbOpen = false;
tag.wrapper = document.querySelector('#wrapper');
tag.target = document.querySelector('header');

function disableScrolling() {
  document.body.style.overflow = 'hidden';
  document.body.style.height = '100%';
}

function enableScrolling() {
  document.body.style.overflow = 'inherit';
  document.body.style.height = 'inherit';
}

function gnbDrop() {
  if (opt.gnbOpen) {
    for (let i = 0; i < tag.dropdownBtn.length; i++) {
      tag.dropdownBtn[i].addEventListener('click', (e) => {
        if (!e.target.classList.contains('ac')) {
          if (e.target.parentNode.parentNode.classList.contains('drop')) {
            e.target.parentNode.parentNode.classList.remove('drop');
          } else {
            for (let j = 0; j < tag.dropdownBtn.length; j++) {
              tag.dropdownBtn[j].parentNode.parentNode.classList.remove('drop');
            }
            e.target.parentNode.parentNode.classList.add('drop');
          }
          e.preventDefault();
        }
      });
    }
  }
}

tag.gnb = document.querySelector('.ch_gnb');
tag.gnb.innerHTML += `
    <div class="inner">
      <h1 class="logo">
        <div class="logo1"><a href="${GNB_BASE_URL}/index.html?v2"><svg xmlns="http://www.w3.org/2000/svg" width="130" height="53" viewBox="0 0 130 53" fill="none">
          <path d="M18.6211 26.8935L30.4546 32.6759L18.6211 43.4848V53L37.25 35.9957V26.4805L25.4087 20.6046L37.25 9.65549V0L18.6211 17.2381V26.8935Z" fill="black"/>
          <path d="M0 39.2532L16.6307 24.1816V23.1763L0 38.2479V39.2532Z" fill="black"/>
          <path d="M0 41.4119L16.6307 26.3403V25.335L0 40.4066V41.4119Z" fill="black"/>
          <path d="M0 34.9359L16.6307 19.8643V18.9369L0 34.0007V34.9359Z" fill="black"/>
          <path d="M0 37.0945L16.6307 22.0229V21.0176L0 36.0892V37.0945Z" fill="black"/>
          <path d="M0 43.5238L16.6307 28.4522V27.4937L0 42.5653V43.5238Z" fill="black"/>
          <path d="M39.2404 29.8548L55.8711 14.7832V13.7701L39.2404 28.8417V29.8548Z" fill="black"/>
          <path d="M39.2404 32.0135L55.8711 16.9419V15.9288L39.2404 31.0004V32.0135Z" fill="black"/>
          <path d="M39.2404 25.5376L55.8711 10.466V9.47626L39.2404 24.5479V25.5376Z" fill="black"/>
          <path d="M39.2404 34.0709L55.8711 18.9993V18.0875L39.2404 33.1591V34.0709Z" fill="black"/>
          <path d="M39.2404 27.6962L55.8711 12.6246V11.6193L39.2404 26.6831V27.6962Z" fill="black"/>
          <path d="M87.8419 16.9186C87.9897 16.7159 88.0985 16.4744 88.1685 16.186C88.2385 15.8977 88.2696 15.586 88.2696 15.2509C88.2696 14.9625 88.254 14.6976 88.2229 14.4716C88.1918 14.2456 88.1374 14.043 88.0519 13.8559C87.9586 13.6845 87.8419 13.5286 87.6787 13.4039C87.5232 13.2715 87.3132 13.1624 87.0644 13.061L86.1936 12.7104C86.0459 12.648 85.9293 12.5935 85.8438 12.5311C85.7582 12.4688 85.696 12.3986 85.6494 12.3207C85.6027 12.235 85.5794 12.1415 85.5639 12.0402C85.5561 11.9389 85.5483 11.8064 85.5483 11.6505C85.5483 11.518 85.5561 11.3856 85.5794 11.2609C85.6027 11.1362 85.6416 11.0271 85.7038 10.9258C85.766 10.8323 85.8438 10.7621 85.9371 10.6998C86.0304 10.6374 86.1625 10.6063 86.318 10.6063C86.6057 10.6063 86.8156 10.6998 86.94 10.8946C87.0644 11.0816 87.1266 11.3154 87.1266 11.5726V11.8298H88.2696V11.2687C88.2696 10.8011 88.0985 10.3958 87.7564 10.0296C87.5854 9.85813 87.3832 9.71786 87.1422 9.61655C86.9089 9.51524 86.6446 9.46069 86.3647 9.46069C86.0304 9.46069 85.7427 9.51524 85.4939 9.63214C85.2529 9.74903 85.0507 9.90489 84.8952 10.0997C84.7319 10.2945 84.6075 10.5283 84.522 10.7933C84.4365 11.066 84.3976 11.3466 84.3976 11.6505C84.3976 12.1493 84.4831 12.5701 84.6464 12.9052C84.8175 13.2403 85.144 13.5052 85.6416 13.7079L86.458 14.043C86.5979 14.1053 86.7146 14.1599 86.8001 14.2144C86.8856 14.269 86.9556 14.3313 87.01 14.417C87.0567 14.5027 87.0878 14.6041 87.1033 14.7443C87.1189 14.8768 87.1266 15.0483 87.1266 15.2587C87.1266 15.4379 87.1266 15.6016 87.1111 15.7496C87.1033 15.8977 87.0644 16.0224 87.0022 16.1237C86.94 16.225 86.8545 16.3107 86.7534 16.3653C86.6446 16.4198 86.4969 16.451 86.3025 16.451C86.0148 16.451 85.8049 16.3653 85.6805 16.2016C85.5561 16.0302 85.4939 15.8431 85.4939 15.6327V15.2743H84.351V15.7029C84.351 15.9756 84.3976 16.225 84.4987 16.451C84.5998 16.677 84.7319 16.8796 84.9108 17.051C85.0818 17.2225 85.2917 17.355 85.525 17.4563C85.766 17.5498 86.0226 17.6043 86.2947 17.6043C86.6601 17.6043 86.9711 17.542 87.2277 17.4251C87.4843 17.3082 87.6864 17.1446 87.8419 16.9342V16.9186Z" fill="black"/>
          <path d="M93.3699 16.3808H91.0996V14.0273H93.0744V12.9519H91.0996V10.6062H93.3699V9.52301H89.9567V17.5264H93.3699V16.3808Z" fill="black"/>
          <path d="M95.4926 17.0978C95.6714 17.2615 95.8736 17.3861 96.1068 17.4719C96.3323 17.5576 96.5656 17.5966 96.7988 17.5966C97.0321 17.5966 97.2575 17.5576 97.4908 17.4719C97.7163 17.3861 97.9262 17.2693 98.1128 17.0978C98.2916 16.9419 98.4393 16.7393 98.5482 16.5055C98.657 16.264 98.7192 15.9756 98.7192 15.6405V11.4167C98.7192 11.0972 98.6648 10.8089 98.5482 10.5595C98.4393 10.3101 98.2916 10.1075 98.1128 9.94386C97.9262 9.788 97.7163 9.66331 97.4908 9.58538C97.2653 9.49966 97.0321 9.46069 96.7988 9.46069C96.5656 9.46069 96.3401 9.49966 96.1068 9.58538C95.8814 9.6711 95.6714 9.788 95.4926 9.94386C95.306 10.1075 95.1583 10.3179 95.0417 10.5595C94.9328 10.8089 94.8706 11.0894 94.8706 11.4167V15.6405C94.8706 15.9756 94.925 16.264 95.0417 16.5055C95.1505 16.7471 95.306 16.9419 95.4926 17.0978ZM96.0213 11.4167C96.0213 11.1362 96.0991 10.9336 96.2546 10.8011C96.4101 10.6686 96.5889 10.6063 96.7988 10.6063C97.0087 10.6063 97.1876 10.6686 97.3431 10.8011C97.4986 10.9336 97.5763 11.1362 97.5763 11.4167V15.6405C97.5763 15.9211 97.4986 16.1237 97.3431 16.2562C97.1876 16.3886 97.0087 16.451 96.7988 16.451C96.5889 16.451 96.4101 16.3886 96.2546 16.2562C96.0991 16.1237 96.0213 15.9211 96.0213 15.6405V11.4167Z" fill="black"/>
          <path d="M101.114 17.0432C101.285 17.2147 101.479 17.3472 101.705 17.4485C101.922 17.542 102.163 17.5965 102.42 17.5965C102.677 17.5965 102.91 17.5498 103.135 17.4485C103.361 17.3549 103.555 17.2147 103.726 17.0432C103.897 16.8718 104.029 16.677 104.123 16.451C104.216 16.2328 104.263 15.9912 104.263 15.7262V9.52301H103.12V15.6093C103.12 15.8977 103.05 16.1003 102.918 16.2406C102.785 16.3808 102.614 16.4432 102.412 16.4432C102.21 16.4432 102.039 16.373 101.907 16.2406C101.775 16.1081 101.705 15.8977 101.705 15.6093V9.52301H100.562V15.7262C100.562 15.9912 100.608 16.2328 100.709 16.451C100.803 16.6692 100.943 16.8718 101.114 17.0432Z" fill="black"/>
          <path d="M109.581 16.3808H107.318V9.52301H106.175V17.5264H109.581V16.3808Z" fill="black"/>
          <path d="M66.7561 26.878H65.341V23.4491H64.1981V31.4447H65.341V27.8833H66.7561V31.4447H67.899V23.4491H66.7561V26.878Z" fill="black"/>
          <path d="M71.0791 23.4491L69.2986 31.4447H70.4415L70.7758 29.7224H72.3308L72.6652 31.4447H73.8081L72.0276 23.4491H71.0713H71.0791ZM70.978 28.647L71.5378 25.748H71.5611L72.1209 28.647H70.978Z" fill="black"/>
          <path d="M76.3583 23.4491H75.2153V31.4447H78.6208V30.2991H76.3583V23.4491Z" fill="black"/>
          <path d="M80.2069 31.4447H81.3498V28.0314H83.3169V26.9559H81.3498V24.5245H83.6124V23.4491H80.2069V31.4447Z" fill="black"/>
          <path d="M89.7235 27.6807H89.7002L88.2307 23.4491H87.1344V31.4447H88.2773V26.5819H88.3006L89.4203 30.0186H89.9878L91.123 26.5819H91.1463V31.4447H92.2892V23.4491H91.1774L89.7235 27.6807Z" fill="black"/>
          <path d="M96.4255 23.4491H95.4692L93.6887 31.4447H94.8316L95.166 29.7224H96.721L97.0553 31.4447H98.1982L96.4177 23.4491H96.4255ZM95.3681 28.647L95.9279 25.748H95.9512L96.511 28.647H95.3681Z" fill="black"/>
          <path d="M103.711 31.4446L102.474 27.7975C102.84 27.5949 103.096 27.33 103.244 27.0027C103.392 26.6753 103.462 26.2701 103.462 25.8025C103.462 24.2361 102.785 23.4568 101.448 23.4568H99.6133V31.4524H100.756V28.0391H101.44L102.506 31.4524H103.718L103.711 31.4446ZM102.288 26.3091C102.265 26.4649 102.226 26.5896 102.163 26.6987C102.094 26.8 102 26.8858 101.884 26.9403C101.767 26.9949 101.604 27.026 101.402 27.026H100.748V24.5323H101.339C101.736 24.5323 102 24.6336 102.148 24.844C102.218 24.9531 102.257 25.0856 102.28 25.2414C102.303 25.3973 102.311 25.5765 102.311 25.7714C102.311 25.9662 102.303 26.1532 102.28 26.3013L102.288 26.3091Z" fill="black"/>
          <path d="M107.443 23.4491H106.486L104.706 31.4447H105.849L106.183 29.7224H107.738L108.073 31.4447H109.215L107.435 23.4491H107.443ZM106.385 28.647L106.945 25.748H106.968L107.528 28.647H106.385Z" fill="black"/>
          <path d="M109.433 24.5245H110.755V31.4447H111.898V24.5245H113.22V23.4491H109.433V24.5245Z" fill="black"/>
          <path d="M117.123 26.878H115.708V23.4491H114.565V31.4447H115.708V27.8833H117.123V31.4447H118.265V23.4491H117.123V26.878Z" fill="black"/>
          <path d="M123.343 23.8621C123.156 23.7062 122.946 23.5815 122.721 23.5036C122.495 23.4179 122.262 23.3789 122.029 23.3789C121.795 23.3789 121.57 23.4179 121.337 23.5036C121.111 23.5893 120.901 23.7062 120.722 23.8621C120.536 24.0257 120.388 24.2361 120.271 24.4777C120.163 24.7271 120.1 25.0076 120.1 25.3349V29.5587C120.1 29.8938 120.155 30.1822 120.271 30.4238C120.38 30.6653 120.536 30.8602 120.722 31.016C120.901 31.1797 121.103 31.3044 121.337 31.3901C121.562 31.4758 121.795 31.5148 122.029 31.5148C122.262 31.5148 122.487 31.4758 122.721 31.3901C122.946 31.3044 123.156 31.1875 123.343 31.016C123.521 30.8602 123.669 30.6575 123.778 30.4238C123.887 30.1822 123.949 29.8938 123.949 29.5587V25.3349C123.949 25.0154 123.895 24.7271 123.778 24.4777C123.669 24.2283 123.521 24.0257 123.343 23.8621ZM122.806 29.5587C122.806 29.8393 122.728 30.0419 122.573 30.1744C122.417 30.3069 122.238 30.3692 122.029 30.3692C121.819 30.3692 121.64 30.3069 121.484 30.1744C121.329 30.0419 121.251 29.8393 121.251 29.5587V25.3349C121.251 25.0544 121.329 24.8518 121.484 24.7193C121.64 24.5868 121.819 24.5245 122.029 24.5245C122.238 24.5245 122.417 24.5868 122.573 24.7193C122.728 24.8518 122.806 25.0544 122.806 25.3349V29.5587Z" fill="black"/>
          <path d="M128.598 28.2652H128.575L126.849 23.4491H125.753V31.4447H126.896V26.6364H126.919L128.668 31.4447H129.741V23.4491H128.598V28.2652Z" fill="black"/>
          <path d="M90.2988 41.2872C90.9441 40.4065 91.3329 39.8922 91.3329 38.6531C91.3329 37.414 90.9674 36.6036 89.6535 36.6036C88.2306 36.6036 87.943 37.6011 87.943 38.4895V38.9181H89.0081V38.5206C89.0081 37.8894 89.1714 37.5699 89.599 37.5699C90.0733 37.5699 90.1744 37.905 90.1744 38.7233C90.1744 39.5883 89.9567 39.8922 89.3191 40.804C88.5028 41.9807 87.9196 42.9315 87.9119 44.3654V44.5056H91.4884V43.5081H89.2025C89.2647 42.8769 89.7234 42.0976 90.3066 41.2872H90.2988Z" fill="black"/>
          <path d="M94.5673 36.6036C93.3622 36.6036 92.7557 37.3595 92.7557 38.7388V42.4717C92.7557 43.6874 93.1678 44.5992 94.5051 44.5992C95.9435 44.5992 96.3322 43.6718 96.3322 42.4561V38.6609C96.3322 37.3439 95.7491 36.6036 94.5673 36.6036ZM95.1815 42.5574C95.1815 43.2198 94.9949 43.5393 94.544 43.5393C94.093 43.5393 93.8909 43.212 93.8909 42.5886V38.5986C93.8909 37.9284 94.1164 37.6478 94.544 37.6478C94.9716 37.6478 95.1815 37.9673 95.1815 38.5752V42.5574Z" fill="black"/>
          <path d="M100.111 41.2872C100.756 40.4065 101.145 39.8922 101.145 38.6531C101.145 37.414 100.779 36.6036 99.4655 36.6036C98.0427 36.6036 97.755 37.6011 97.755 38.4895V38.9181H98.8201V38.5206C98.8201 37.8894 98.9834 37.5699 99.4111 37.5699C99.8853 37.5699 99.9864 37.905 99.9864 38.7233C99.9864 39.5883 99.7687 39.8922 99.1312 40.804C98.3148 41.9807 97.7317 42.9315 97.7239 44.3654V44.5056H101.3V43.5081H99.0145C99.0767 42.8769 99.5355 42.0976 100.119 41.2872H100.111Z" fill="black"/>
          <path d="M104.302 39.4168C103.905 39.4168 103.602 39.5805 103.392 39.7597V38.6064C103.392 37.9362 103.625 37.6556 104.053 37.6556C104.481 37.6556 104.714 37.866 104.714 38.583H105.795C105.795 37.2894 105.188 36.6036 104.076 36.6036C102.871 36.6036 102.265 37.3595 102.265 38.7388V42.4717C102.265 43.6874 102.677 44.5992 104.014 44.5992C105.452 44.5992 105.826 43.6718 105.826 42.4561V41.2092C105.826 40.1961 105.266 39.4246 104.309 39.4246L104.302 39.4168ZM104.69 42.6899C104.69 43.2666 104.504 43.5471 104.053 43.5471C103.602 43.5471 103.4 43.2666 103.4 42.7211V41.3027C103.4 40.7261 103.625 40.4767 104.053 40.4767C104.481 40.4767 104.69 40.7572 104.69 41.2794V42.6899Z" fill="black"/>
          </svg></a></div>
        <div class="logo2"><a href="${GNB_BASE_URL}/index.html?v2"><img src="https://image.chosun.com/halfmarathon/2024/logo_pro.png" alt="chuncheon marathon"></a></div>
      </h1>
      <div class="cate">
        <nav class="menu-box-1">
            <ul class="menu_wrap">
                <li>
                    <span><a href="${GNB_BASE_URL}/rally/info.html" class="menu_2_bg">대회안내</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li>
                            <a href="${GNB_BASE_URL}/rally/info.html">대회요강</a>
                        </li>
                        <li>
                            <a href="${GNB_BASE_URL}/rally/notes.html">대회유의사항</a>
                        </li>
                        <li><a href="${GNB_BASE_URL}/rally/logo.html">서울하프마라톤 CI</a></li>
                    </ul>
                </li>
                <li>
                    <span><a href="${GNB_BASE_URL}/apply/part-method.html" class="menu_2_bg">참가신청</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li><a href="${GNB_BASE_URL}/apply/part-method.html">신청방법</a></li>
                        <li class="sh_part1"><a href="#">신청하기</a></li>
                        <li><a href="${GNB_BASE_URL}/apply/part-confirm.html">신청확인/결제</a></li>
                        <li><a href="${GNB_BASE_URL}/apply/part-agreement.html">참가자 동의사항</a></li>
                    </ul>
                </li>
                <li>
                    <span><a href="${GNB_BASE_URL}/course/info.html" class="menu_2_bg">대회코스</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li><a href="${GNB_BASE_URL}/course/info.html">코스도</a></li>
                        <li><a href="${GNB_BASE_URL}/course/trafic.html">교통통제 시간표</a></li>
                        <li><a href="${GNB_BASE_URL}/course/sitemap.html">대회장 안내</a></li>
                    </ul>
                </li>
                <li>
                    <span><a href="${GNB_BASE_URL}/gift/info.html" class="menu_2_bg">기념품</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li><a href="${GNB_BASE_URL}/gift/info.html">기념품</a></li>
                    </ul>
                </li>
                <li>
                    <span><a href="${GNB_BASE_URL}/record/tournament.html" class="menu_2_bg">대회기록</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li><a href="${GNB_BASE_URL}/record/tournament.html">기록 조회</a></li>
                        <li><a href="${GNB_BASE_URL}/record/all-time.html">역대 기록</a></li>
                    </ul>
                </li>
                <li>
                    <span><a href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10006&branch=&pn=1" class="menu_2_bg">커뮤니티</a></span>
                    <ul class="menu-box-2 gnb_mobile">
                        <li><a href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10006&branch=&pn=1">공지사항</a></li>
                        <li><a href="${GNB_BASE_URL}/community/faq.html">FAQ</a></li>
                    </ul>
                </li>
            </ul>
        </nav>
      </div>
      <div class="cate_menu_bg">
        <div class="cate_menu_wrap">
          <ul class="menu-box-2 gnb_pc">
            <li>
                <a href="${GNB_BASE_URL}/rally/info.html">대회요강</a>
            </li>
            <li>
                <a href="${GNB_BASE_URL}/rally/notes.html">대회유의사항</a>
            </li>
            <li><a href="${GNB_BASE_URL}/rally/logo.html">서울하프마라톤 CI</a></li>
          </ul>
          <ul class="menu-box-2 gnb_pc">
            <li><a href="${GNB_BASE_URL}/apply/part-method.html">신청방법</a></li>
            <li class="sh_part2"><a href="#">신청하기</a></li>
            <li><a href="${GNB_BASE_URL}/apply/part-confirm.html">신청확인/결제</a></li>
            <li><a href="${GNB_BASE_URL}/apply/part-agreement.html">참가자 동의사항</a></li>
          </ul>
          <ul class="menu-box-2 gnb_pc">
            <li><a href="${GNB_BASE_URL}/course/info.html">코스도</a></li>
            <li><a href="${GNB_BASE_URL}/course/trafic.html">교통통제 시간표</a></li>
            <li><a href="${GNB_BASE_URL}/course/sitemap.html">대회장 안내</a></li>
          </ul>
          <ul class="menu-box-2 gnb_pc mg-lg">
            <li><a href="${GNB_BASE_URL}/record/tournament.html">기록 조회</a></li>
            <li><a href="${GNB_BASE_URL}/record/all-time.html">역대 기록</a></li>
          </ul>
          <ul class="menu-box-2 gnb_pc">
            <li><a href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10006&branch=&pn=1">공지사항</a></li>
            <li><a href="${GNB_BASE_URL}/community/faq.html">FAQ</a></li>
          </ul>
        </div>
      </div>
      <div class="gnb_menu_pc"><button><img src="https://image.chosun.com/chuncheonmarathon/2023/main/menu_btn_black.png" alt="category button"></button></div>
      <div class="close_btn"><img src="https://image.chosun.com/chuncheonmarathon/2023/main/close.png" alt="close" /></div>
      <div class="gnb_menu_btn"><!--<button><img src="https://image.chosun.com/chuncheonmarathon/2023/main/menu_btn.png" alt="category button">--><img src="https://image.chosun.com/chuncheonmarathon/2023/main/menu_btn_black.png" alt="category button"></button></div>
    </div>
`;

tag.gnbOpenBtn = document.querySelector('.gnb_menu_btn');
tag.gnbCloseBtn = document.querySelector('.close_btn');
tag.dropdownBtn = document.querySelectorAll('.menu_2_bg');
tag.topNotice = document.querySelector('.top_notice a');
tag.alertCate = document.querySelectorAll('.alert_cate');
tag.part = document.querySelector('.sh_part1');
tag.part2 = document.querySelector('.sh_part2');
tag.menu_taggle = document.querySelectorAll('.menu-box-1>ul');
tag.gnb_menu_btn = document.querySelector('.gnb_menu_pc');
tag.menu_box_2 = document.querySelectorAll('.menu-box-2');

tag.gnbOpenBtn.addEventListener('click', (e) => {
  tag.gnb.classList.add('on');
  opt.gnbOpen = true;
  disableScrolling();
  gnbDrop();
  e.preventDefault();
});

tag.gnbCloseBtn.addEventListener('click', (e) => {
  tag.gnb.classList.remove('on');
  opt.gnbOpen = false;
  enableScrolling();
  e.preventDefault();
});

for (let i = 0; i < tag.menu_taggle.length; i++) {
  tag.menu_taggle[i].addEventListener('mouseenter', () => {
    tag.gnb.classList.add('on');
  });
}

for (let i = 0; i < tag.menu_taggle.length; i++) {
  tag.menu_taggle[i].addEventListener('mouseleave', () => {
    tag.gnb.classList.remove('on');
  });
}

tag.gnb_menu_btn.addEventListener('mouseenter', () => {
  tag.gnb.classList.add('on');
});

tag.gnb_menu_btn.addEventListener('mouseleave', () => {
  tag.gnb.classList.remove('on');
});

tag.part.addEventListener('click', (e) => {
  location.href = `${GNB_BASE_URL}/apply/part-application.html?v4`;

  e.preventDefault();
});

tag.part2.addEventListener('click', (e) => {
  location.href = `${GNB_BASE_URL}/apply/part-application.html?v4`;

  e.preventDefault();
});

const stickyMenu = () => {
  const offsetY = window.scrollY;
  const stickyPos = tag.gnb.offsetHeight;
  if (offsetY >= stickyPos) {
    tag.gnb.classList.add('sticky');
  } else {
    tag.gnb.classList.remove('sticky');
  }
};

// eslint-disable-next-line import/prefer-default-export
export const mainFn = () => {
  const listRenderTarget = document.querySelector('#notice ul');

  const getBoardData = async () => {
    try {
      const response = await fetch(`${LOAD_BASE_URL}/json/half-board.json`);
      const data = await response.json();
      // eslint-disable-next-line no-use-before-define
      renderList(data);
    } catch (e) {
      console.log(e);
    }
  };

  const renderList = (res) => {
    res.data.forEach((item, i) => {
      if (i < 5) {
        listRenderTarget.innerHTML += `
          <li>
            <a href="https://board.chosun.com/${item.link}" target="_blank">
              <span class="icon">${item.category}</span>
              <span class="tt">${item.title}</span>
            </a>
            <span class="date">${item.regdate.split(' ')[0]}</span>
          </li>
        `;
      }
    });
  };

  return {
    listHandler: () => {
      if (listRenderTarget) {
        getBoardData();
      }
    },
  };
};

document.addEventListener('scroll', stickyMenu);
